module.exports = __webpack_public_path__ + "static/img/index_item2_bg.bb39e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/index_item2_bg.png
// module id = F3vw
// module chunks = 0